module.exports = __webpack_public_path__ + "img/1.e21edcc5.png";